export var allowedLocales = ['en', 'ru', 'it', 'es', 'de', 'zh', 'el'];
export var checkLocale = function checkLocale(val) {
  return typeof val === 'string' && allowedLocales.includes(val.toLowerCase()) ? val.toLowerCase() : 'ru';
};